import Constants from 'expo-constants';

function getRequiredEnvString(envVar: string): string {
  const _envVariable = getEnvString(envVar);

  if (!_envVariable) {
    throw new Error(`Missing required environment variable: ${envVar}`);
  }

  return _envVariable;
}

function getEnvString(envVar: string): string | undefined {
  return Constants.expoConfig?.extra?.[envVar];
}

export const env = {
  API_BASE_URL: getRequiredEnvString('API_BASE_URL'),
  USA_API_BASE_URL: getEnvString('USA_API_BASE_URL'),
  APP_ENV: getRequiredEnvString('APP_ENV'),
  APP_NAME: getRequiredEnvString('APP_NAME'),
  APPLE_APP_ID: getRequiredEnvString('APPLE_APP_ID'),
  BUNDLE_ID: getRequiredEnvString('BUNDLE_ID'),
  COGNITO_AWS_REGION: getRequiredEnvString('COGNITO_AWS_REGION'),
  COGNITO_CLIENT_ID: getRequiredEnvString('COGNITO_CLIENT_ID'),
  COGNITO_USER_POOL_ID: getRequiredEnvString('COGNITO_USER_POOL_ID'),
  CUSTOMERIO_API_KEY: getRequiredEnvString('CUSTOMERIO_API_KEY'),
  CUSTOMERIO_CDP_API_KEY: getRequiredEnvString('CUSTOMERIO_CDP_API_KEY'),
  CUSTOMERIO_SITE_ID: getRequiredEnvString('CUSTOMERIO_SITE_ID'),
  DEFAULT_USERNAME: getEnvString('DEFAULT_USERNAME'),
  DEFAULT_PASSWORD: getEnvString('DEFAULT_PASSWORD'),
  DEFAULT_POSTAL_CODE: getEnvString('DEFAULT_POSTAL_CODE'),
  DEFAULT_FIRST_NAME: getEnvString('DEFAULT_FIRST_NAME'),
  DEFAULT_LAST_NAME: getEnvString('DEFAULT_LAST_NAME'),
  DEFAULT_PHONE: getEnvString('DEFAULT_PHONE'),
  // FROM https://console.cloud.google.com/apis/credentials/oauthclient/102461592891-58bnlbmll5hsb4r24c595njcommi7m4v.apps.googleusercontent.com?authuser=0&project=partage-club-development&supportedpurview=project
  GOOGLE_CLIENT_ID: getRequiredEnvString('GOOGLE_CLIENT_ID'),
  GOOGLE_TAG_MANAGER_ID: getEnvString('GOOGLE_TAG_MANAGER_ID'),
  IMGPROXY_ENDPOINT: getRequiredEnvString('IMGPROXY_ENDPOINT'),
  MIXPANEL_TOKEN: getRequiredEnvString('MIXPANEL_TOKEN'),
  STRIPE_PUBLISHABLE_KEY: getRequiredEnvString('STRIPE_PUBLISHABLE_KEY'),
  APPLE_PAY_MERCHANT_ID: getRequiredEnvString('APPLE_PAY_MERCHANT_ID'),
  APPLE_AUTH_CLIENT_ID: getRequiredEnvString('APPLE_AUTH_CLIENT_ID'),
  OAUTH_REDIRECT_URI: getRequiredEnvString('OAUTH_REDIRECT_URI'),
  UNIVERSAL_LINK_HOSTNAME: getRequiredEnvString('UNIVERSAL_LINK_HOSTNAME'),
  IS_PARTAKE: Constants.expoConfig?.extra?.IS_PARTAKE === true,
  GOOGLE_MAPS_API_KEY_WEB: getRequiredEnvString('GOOGLE_MAPS_API_KEY_WEB'),
};
